<template>
  <validation-provider v-slot="validationContext" :vid="vid" :name="labelText" :rules="rules" :custom-messages="customMessages" slim>
    <b-form-group
      :label-for="'select-' + id"
      label-class="d-inline"
      class="vueSelectPickerArea"
      :class="[Object.keys(validationContext.failedRules).length !== 0 ? 'error' : null, formGroupClass]"
    >
      <template v-if="labelText" #label>
        {{ labelText }}
        <span v-if="requiredStar" class="text-danger">*</span>
      </template>

      <b-form-select
        :id="'select-' + id"
        v-model="displayModel"
        class="selectpicker"
        :class="selectClass"
        :data-container="dataContainer"
        :data-width="dataWidth"
        :data-size="dataSize"
        :data-live-search="dataLiveSearch"
        :multiple="multiple"
        :data-selected-text-format="dataSelectedTextFormat"
        :title="selectTitleText"
        :disabled="disabled"
        :options="options"
        :text-field="textField"
        :value-field="valueField"
        :state="getValidationState(validationContext)"
        :data-actions-box="dataActionsBox"
        @change="changeEvent($event)"
      >
        <!-- :selected="selected" -->
        <template v-if="singleDeselect" #first>
          <b-form-select-option :value="'deSelect'" class="singleDeselectOption">{{ $t("deselect") }}</b-form-select-option>
        </template>
      </b-form-select>
      <b-form-invalid-feedback :id="'select-' + id" class="invalid-feedback-inline">
        {{ validationContext.errors[0] ? validationTextFormat(validationContext.errors[0]) + "." : null }}
      </b-form-invalid-feedback>
    </b-form-group>
  </validation-provider>
</template>

<script>
import Vue from "vue";
import baseModelEmitter from "../../mixins/baseModelEmitter";
import { FormGroupPlugin, FormSelectPlugin, FormPlugin } from "bootstrap-vue";

Vue.use(FormGroupPlugin);
Vue.use(FormSelectPlugin);
Vue.use(FormPlugin);

export default {
  name: "BaseSelect",
  mixins: [baseModelEmitter],
  props: {
    // selected: null,
    selected: {
      type: [String, Number, Array, Object, Boolean],
      default: null,
    },
    options: {
      type: Array,
      default: () => [],
    },
    selectTitle: {
      type: String,
      default: null,
    },
    requiredStar: {
      type: Boolean,
      default: false,
    },
    labelText: {
      type: String,
      default: "",
    },
    dataLiveSearch: {
      type: Boolean,
      default: false,
    },
    dataSize: {
      type: Number,
      default: 4,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    dataWidth: {
      type: String,
      default: null,
    },
    dataContainer: {
      type: String,
      default: null,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    dataSelectedTextFormat: {
      type: String,
      default: null,
    },
    formGroupClass: {
      type: String,
      default: null,
    },
    selectClass: {
      type: String,
      default: null,
    },
    customMessages: {
      type: Object,
      default: () => ({}),
    },
    rules: {
      type: [String, Object],
      default: null,
    },
    textField: {
      type: String,
      default: null,
    },
    valueField: {
      type: String,
      default: null,
    },
    vid: {
      type: String,
      default: null,
    },
    dataActionsBox: {
      type: Boolean,
      default: false,
    },
    singleDeselect: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedOption: null,
      id: Math.floor(Math.random() * 10100).toString(),
      inputModel: null,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.displayModel = this.selected;
      $(".selectpicker").selectpicker("refresh");
      this.selectLiveSearchNormalize();
    });
  },
  updated() {
    $(this.$el).find(".selectpicker").selectpicker("refresh");
  },
  destroyed() {
    $(this.$el).find(".selectpicker").off().selectpicker("destroy");
  },

  computed: {
    selectTitleText() {
      return this.selectTitle === null || this.selectTitle === undefined ? this.$t("choose") : this.selectTitle;
    },
  },
  methods: {
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    validationTextFormat(text) {
      let fiterText = text.split(" ");
      let returnText = fiterText[0];
      for (let i = 1; i < fiterText.length; i++) {
        returnText += " " + fiterText[i].charAt(0).replace(/İ/gim, "i").toLowerCase() + fiterText[i].slice(1).toLowerCase();
      }
      return returnText;
    },
    selectLiveSearchNormalize() {
      $(".selectpicker").selectpicker({ liveSearchNormalize: true });
    },
    changeEvent(event) {
      if (event === "deSelect") {
        this.displayModel = null;
      }
      this.$emit("changeEvent");
    },
  },
};
</script>

<style lang="scss" scoped></style>
